<template lang="pug">
.toolbar-container
  .bottom-toolbar.color_text_3
    .message-center(v-if="isLogin")
      span(@click="goToMessageCenter") 消息中心
      .message-point(v-if="hasUnread")
        .message-point-inner
    .line(v-if="isLogin") |
    .vip-recharge(v-if="isLogin && isSVip")
      span(@click="buyRecharge" ) 购买加量包
      img.icon(src="@/assets/imgs/vip/light/questionmark.png" @mouseenter="mouseenter" @mouseleave="mouseleave")
      .recharge-desc.color_label_2.color_text_2.color_divider_2_border(v-if="isShowDesc") 可享受更多翻译额度
    .line(v-if="isLogin && isSVip") |
    //- .help
    //-   span(@click="viewMore") 帮助与反馈
    //- .line |
    .exchange
      span(@click="openExchange") 兑换码开通
    .line |
    .Invoice
      span(@click="gotoInvoice") 我要开票
      .new-tag NEW
    .line(v-if="isLogin") |
    .welfare(v-if="isLogin")
      span(@click="gotoWelfare") 我的福利
  exchangePopUp(ref="exchangePopUp" @exchange="exchange")
  morePackage(v-if='showMore' @closeMorePackage='closeMorePackage')
  vipWelfare(v-if="showVipWelfare" @closeVipWelfare='closeVipWelfare' @openMorePackage="openMorePackage")
  MessageCenter(v-if="showMessageCenter" @closeMessageCenter="closeMessageCenter")
</template>
<script>
import exchangePopUp from '@/components/exchangePopUp.vue';
import morePackage from '@/components/morePackage.vue';
import vipWelfare from '@/components/vipWelfare.vue';
import MessageCenter from '@/components/MessageCenter.vue';
import vip from '@/service/vip';
import v3 from '@/util/v3';

export default {
  props: ['isSVip', 'isLogin'],
  components: {
    exchangePopUp,
    morePackage,
    vipWelfare,
    MessageCenter,
  },
  data() {
    return {
      isShowDesc: false,
      source: '',
      hasUnread: false,
      showMore: false,
      showVipWelfare: false,
      showMessageCenter: false,
    };
  },
  mounted() {
    this.source = this.$route.query.source || '';
    this.checkUnreadMsg();
  },
  methods: {
    openMorePackage() {
      this.showMore = true;
    },
    // 跳转购买加量包窗口
    buyRecharge() {
      this.showMore = true;
    },
    closeMorePackage() {
      this.showMore = false;
    },
    gotoWelfare() {
      this.showVipWelfare = true;
    },
    closeVipWelfare() {
      this.showVipWelfare = false;
    },
    mouseenter() {
      this.isShowDesc = true;
    },
    mouseleave() {
      this.isShowDesc = false;
    },
    // viewMore() {
    //   /* eslint-disable */
    //   // 设置页面在10.0.0和10.0.6版本做了升级，url变了
    //   var settingPageSrc;
    //   if(!window._desk_dict_wins_ || !window._desk_dict_wins_.semverGE("10.0.0")){
    //     settingPageSrc = "html/index.html#/setting/feedback";
    //   }
    //   else if(window._desk_dict_wins_.semverGE("10.0.0") && !window._desk_dict_wins_.semverGE("10.0.6")){
    //     settingPageSrc = "html/ydDict/setting.html#/setting/feedback";
    //   }
    //   else{
    //     settingPageSrc = "html/ydDict/setting_setting_feedback.html#/setting/feedback";
    //   }
    //   window.ydk.openWin({
    //     src: settingPageSrc,
    //     name: 'setting',
    //   });
    // },
    openExchange() {
      this.$refs.exchangePopUp.showPopUp();
    },
    exchange(val) {
      const param = {
        imei: '1',
        keyfrom: 'webdict',
        apiversion: '1.0',
        platform: 'webdict',
        code: val,
      };
      vip.exchangeVipCode(param).then((res) => {
        if (res.success) {
          this.$toast('兑换成功');
          // 更新vip当前页面
          window.location.reload(true);
        } else if (res.errorCode === 2308) {
          this.$toast('兑换请求频繁');
        } else if (res.errorCode === 2309) {
          this.$toast('会员码兑换失败（已经是VIP会员）');
        } else if (res.errorCode === 2310) {
          this.$toast('会员码兑换失败（会员码已过期）');
        } else if (res.errorCode === 2311) {
          this.$toast('会员码兑换失败（会员码已被使用）');
        } else if (res.errorCode === 2312) {
          this.$toast('会员码兑换失败（会员码不存在）');
        } else {
          this.$toast('会员码兑换失败');
        }
      });
    },
    gotoInvoice() {
      window.open('https://c.youdao.com/dict/vip/invoice.html', '_blank');
    },
    // 查询消息中心未读消息
    async checkUnreadMsg() {
      try {
        const keyid = 'dict-message-center';
        const key = 'TphDcvmBvc12dzla';
        const requestData = {
          // app: utilIndex.getPlafrom() === 'mac' ? 'macdict_bkd' : 'deskdict_bkd',
          app: 'deskdict_bkd',
          type: 'msg',
          userType: this.isSVip ? 'vip' : 'nonVip',
        };
        const v3Param = v3.genParamV3({}, key, keyid, 'web', 'webdict', '1', '1', 'web', '', '', '', '', '1');
        const res = await vip.getMessageUnread({
          ...v3Param,
          ...requestData,
        });
        this.hasUnread = !!res.totalUnRead;
      } catch (e) {
        this.hasUnread = false;
      }
    },
    // 打开消息中心
    goToMessageCenter() {
      this.hasUnread = false;
      this.showMessageCenter = true;
    },
    closeMessageCenter() {
      this.showMessageCenter = false;
    },
  },
};
</script>
<style lang="stylus" scoped>
.bottom-toolbar
  position: absolute
  right: 24px
  bottom 10px
  width fit-content
  height 20px
  display: flex
  .vip-recharge, .help, .exchange, .Invoice, .welfare, .message-center
    font-size 12px
    margin 0px 5px
    cursor pointer
  .line
    position relative
    bottom 1px
  .vip-recharge
    position relative
    .icon
      width 12px
      height 12px
      vertical-align: middle
      margin-left 3.5px
      margin-bottom 3px
    .recharge-desc
      box-shadow 0px 1.2px 3.6px rgba(0, 0, 0, 0.1), 0px 6.4px 14.4px rgba(0, 0, 0, 0.13)
      border-radius 4px
      font-size 12px
      text-align center
      width 146px
      height 28px
      line-height 28px
      z-index 100
      position absolute
      top -34px
      right 0
  .Invoice
    position relative
    .new-tag
      position: absolute
      width 26px
      height 13px
      line-height: 13px
      text-align: center
      color #fff
      background: linear-gradient(97.76deg, #FF635E -1.73%, #FF825E 100.77%);
      border-radius 6px 3px 6px 3px
      box-shadow: 0px 1px 8px 0px #CD27271A;
      font-size 9px
      top -13px
      right -14px
  .message-center
    vertical-align: middle
    .message-point
      vertical-align: middle
      display inline-block
      margin-left 4px
      width 6px
      height 6px
      border-radius 50%
      border 1px solid #FB4A3E
      padding 2px
      .message-point-inner
        width 100%
        height 100%
        border-radius 50%
        background #FB4A3E
</style>
